import React from 'react';

function BedHeadPanel() {
  return (
    <>
      <style>{`
        .cont {
          text-align: center;
          padding: 2rem;
          background-color: #f9f9f9;
        }

        .cont h1 {
          font-size: 2.5rem;
          margin-bottom: 2rem;
          color: #2c3e50;
        }

        .image-grid {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 2rem;
          flex-wrap: wrap;
        }

        .image-grid img {
          width: 100%;
          max-width: 400px;
          border-radius: 10px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }

        .description {
          max-width: 900px;
          margin: 2rem auto;
          padding: 2rem;
          background-color: #ffffff;
          border-radius: 10px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.05);
        }

        .description h3 {
          font-size: 2rem;
          color: #34495e;
          margin-bottom: 1rem;
        }

        .description p {
          font-size: 1.1rem;
          color: #555;
          line-height: 1.6;
        }

        .description ul {
          margin-top: 1rem;
          padding-left: 1.5rem;
        }

        .description li {
          font-size: 1rem;
          margin-bottom: 0.75rem;
          color: #333;
          line-height: 1.5;
        }

        @media (max-width: 768px) {
          .cont h1 {
            font-size: 2rem;
          }

          .description h3 {
            font-size: 1.5rem;
          }

          .image-grid {
            flex-direction: column;
          }
        }
      `}</style>

      <main>
        <div className="cont">
          <h1>Bed Head Panel</h1>
          <div className="image-grid">
            <img src="bhp2.png" alt="Bed Head Panel 1" />
            <img src="bhp.png" alt="Bed Head Panel 2" />
          </div>
        </div>

        <div className="description">
          <h3>Bed Head Panel</h3>
          <p>
            We offer a superior range of bed head panels constructed using extruded aluminum,
            designed for modern healthcare needs. Key features include:
          </p>
          <ul>
            <li>The extruded aluminum structural lower channel includes a vertical integrated equipment mounting track to support optional equipment.</li>
            <li>Optional equipment such as IV hooks, infusion poles, utility baskets, and monitor trays can be mounted anywhere along the track.</li>
            <li>Gas outlets, switch sockets, monitor sockets, and nurse call systems can be fitted in the middle section of the unit as per hospital requirements.</li>
          </ul>
        </div>
      </main>
    </>
  );
}

export default BedHeadPanel;
